import axios from 'axios';
import { merge } from 'lodash';
import { getToken } from 'utils/auth-token';

export const subscribeToErrorResponse = (cb) => {
  axios.interceptors.response.use(null, cb);
};

export default async function requester({
  method = 'get',
  url,
  data = undefined,
  headers = {},
  extendHeadersWithSession = true,
  params = {},
  ...rest
}) {
  const { value: authToken } = getToken();

  const modifiedHeaders = merge(
    extendHeadersWithSession ? { 'X-Auth-Token': authToken } : {},
    headers,
  );

  const response = await axios({
    method,
    url,
    data,
    headers: modifiedHeaders,
    withCredentials: false,
    validateStatus: function (status) {
      return status >= 200 && status < 300; // default
    },
    params,
    ...rest,
  });

  return response.data;
}
